export const getHasHangerFrame = (items: any) => {
  return items.some((item) => /HF[0-9]{1,2}/gm.test(item.sku));
};
